// extracted by mini-css-extract-plugin
export default {"navbar":"Layout_navbar__EGQW6","dashboard":"Layout_dashboard__qj2jA","mainContent":"Layout_mainContent__ZHlUv","noScroll":"Layout_noScroll__4AUdT","footer":"Layout_footer__et80I"};